import React from "react";
import { FieldFormV2, LoadingV2 } from "@ucl/library";
import { useCreditAuthorizationForm } from "@/hooks/useCreditAuthorizationForm";
import { CreditAuthorizationUpdateDTO } from "@/types/CreditAuthorizationUpdateDTO";
import { CreditAuthorizationDecisionField } from "./CreditAuthorizationDecisionField";

export interface CreditAuthorizationFormProps {
  creditAuthorizationId: string;
  showBrowserTabMessage?: boolean;
}

export const CreditAuthorizationForm: React.FC<CreditAuthorizationFormProps> = ({
  creditAuthorizationId,
  showBrowserTabMessage = true,
}) => {
  const {
    formValue,
    setFormValue,
    saveFormData,
    schemaFactory,
    formBuilder,
    fieldFormModule,
    loading,
    error,
    isSafeToCloseBrowserTab,
  } = useCreditAuthorizationForm(creditAuthorizationId);

  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <LoadingV2 />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f8d7da",
          border: "1px solid #f5c6cb",
          borderRadius: "4px",
          color: "#721c24",
        }}
      >
        Error: {error}
      </div>
    );
  }

if (!schemaFactory || !formBuilder || !formValue) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <LoadingV2 />
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <FieldFormV2<CreditAuthorizationUpdateDTO>
      ref={fieldFormModule}
      value={formValue}
      fieldSchemaFormBuilder={formBuilder}
      onFormSubmit={async (value) => {
        await saveFormData(value);
      }}
      onFieldChanged={(newValue, newFieldValue, _fieldProps) => {
        setFormValue(newValue, newFieldValue);
      }}
      errors={{}}
    >
      <CreditAuthorizationDecisionField
        value={formValue}
        onChange={setFormValue}
        disabled={loading}
      />
    </FieldFormV2>
    
    {showBrowserTabMessage && isSafeToCloseBrowserTab && (
      <div 
        style={{ 
          marginTop: "20px",
          backgroundColor: "var(--ucl-primary-light)",
          border: "1px solid var(--ucl-primary)",
          borderLeft: "4px solid var(--ucl-primary)",
          borderRadius: "var(--ucl-border-radius)",
          padding: "1rem 1.5rem",
          boxShadow: "0 1px 3px var(--ucl-shadow)"
        }}
      >
        <p style={{ 
          fontSize: "16px", 
          lineHeight: "1.6", 
          color: "#333", 
          margin: "0",
          fontWeight: "500"
        }}>
          Thank you for your selection, you may now close this browser session.
        </p>
      </div>
    )}
    </div>
  );
};
